import React from "react";
import { BookOpen, Target, Clock, TrendingUp, Award } from "lucide-react";

const SubjectPerformanceSection = ({ subjectData }) => {
  const getAccuracyColor = (accuracy) => {
    if (accuracy >= 90)
      return "bg-emerald-50 text-emerald-700 border-emerald-200";

    if (accuracy >= 70) return "bg-blue-50 text-blue-700 border-blue-200";

    if (accuracy >= 50) return "bg-amber-50 text-amber-700 border-amber-200";

    return "bg-red-50 text-red-700 border-red-200";
  };

  const getBarColor = (accuracy) => {
    if (accuracy >= 90) return "bg-emerald-500";
    if (accuracy >= 70) return "bg-blue-500";
    if (accuracy >= 50) return "bg-amber-500";
    return "bg-red-500";
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      {/* Header */}
      <div className="mb-4">
        <h2 className="font-semibold text-gray-900">Subject Performance</h2>
      </div>

      <div className="space-y-3">
        {subjectData.map((subject, index) => (
          <div key={index} className="border border-gray-100 rounded-lg p-3">
            {/* Top Row */}
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-2 min-w-0">
                <BookOpen className="w-4 h-4 text-blue-600 flex-shrink-0" />

                <div className="min-w-0">
                  <div className="text-sm font-semibold text-gray-900 truncate">
                    {subject.subject}
                  </div>

                  <div className="text-[11px] text-gray-500">
                    {subject.totalQuestions} Q • {subject.attempts} Attempts
                  </div>
                </div>
              </div>

              <div
                className={`px-2 py-1 rounded-md border text-xs font-semibold whitespace-nowrap ${getAccuracyColor(
                  subject.accuracy,
                )}`}
              >
                {subject.accuracy}%
              </div>
            </div>

            {/* Metrics */}
            <div className="grid grid-cols-4 gap-2 mt-3">
              <div className="flex items-center gap-1">
                <Award className="w-3.5 h-3.5 text-purple-600" />
                <div>
                  <div className="text-xs text-gray-500">Score</div>
                  <div className="text-sm font-semibold">
                    {subject.averagePercentage}%
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-1">
                <Target className="w-3.5 h-3.5 text-emerald-600" />
                <div>
                  <div className="text-xs text-gray-500">Accuracy</div>
                  <div className="text-sm font-semibold">
                    {subject.accuracy}%
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-1">
                <Clock className="w-3.5 h-3.5 text-orange-600" />
                <div>
                  <div className="text-xs text-gray-500">Time/Q</div>
                  <div className="text-sm font-semibold">
                    {subject.avgTimePerQuestion}s
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-1">
                <TrendingUp className="w-3.5 h-3.5 text-blue-600" />
                <div>
                  <div className="text-xs text-gray-500">Attempts</div>
                  <div className="text-sm font-semibold">
                    {subject.attempts}
                  </div>
                </div>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="mt-3">
              <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className={`h-full ${getBarColor(
                    subject.accuracy,
                  )} rounded-full transition-all duration-500`}
                  style={{
                    width: `${subject.accuracy}%`,
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubjectPerformanceSection;
